import { Components, Theme } from '@mui/material'

export const MuiFormHelperText: Components<Omit<Theme, 'components'>>['MuiFormHelperText'] = {
  defaultProps: {
    margin: 'dense',
    sx: { marginLeft: '4px' },
  },
}
